import moment from "moment"

export const ADD_OTP_EXPIRY = 'ADD_OTP_EXPIRY'
export const CLEAR_OTP_EXPIRY = 'CLEAR_OTP_EXPIRY'
export const ADD_SECURITY_CODE = 'ADD_SECURITY_CODE'
export const CLEAR_SECURITY_CODE = 'CLEAR_SECURITY_CODE'

const initialState = {
  otpExpiry: null,
  securityCode: ""
}

export const addOTPExpiry = payload => ({
  type: ADD_OTP_EXPIRY,
  payload,
})

export const clearOTPExpiry = payload => ({
  type: CLEAR_OTP_EXPIRY,
  payload,
})

export const addSecurityCode = payload => ({
  type: ADD_SECURITY_CODE,
  payload,
})

export const clearSecurityCode = payload => ({
  type: CLEAR_SECURITY_CODE,
  payload,
})

export default ( state = initialState, action ) => {
  switch( action.type ) {
    case ADD_OTP_EXPIRY:
      return {
        ...state,
        otpExpiry: moment().add(180, "seconds").toString()
      }
    case CLEAR_OTP_EXPIRY:
      return {
        ...state,
        otpExpiry: null
      }
    case ADD_SECURITY_CODE:
      return {
        ...state,
        securityCode: action.payload
      }
    case CLEAR_SECURITY_CODE:
      return {
        ...state,
        securityCode: ""
      }
    default: return state
  }
}